export const SCRIPT_DATES_ERROR = 'SCRIPT_DATES_ERROR';
export const SCRIPT_DATES_GET = 'GET_SCRIPT_DATES_INIT';
export const SCRIPT_DATES_GET_ALL = ' SCRIPT_DATES_GET_ALL';
export const SCRIPT_DATES_COUNT = 'GET_SCRIPT_DATES_COUNT';
export const SCRIPT_DATES_SAVE = 'GET_SCRIPT_DATES_SAVE';
export const SCRIPT_DATES_ADD_UPDATE = 'GET_SCRIPT_DATES_ADD_UPDATE';
export const SCRIPTS_DATE_CLEAR = 'SCRIPTS_DATE_CLEAR';
export const SCRIPT_DATES_CLEAR_ALL_UPDATES = 'SCRIPT_DATES_CLEAR_ALL_UPDATES';
export const SCRIPT_DATES_REMOVE_ALL_EDITS = 'SCRIPT_DATES_REMOVE_ALL_EDITS';
export const SCRIPT_DATES_GET_REFINE = 'SCRIPT_DATES_GET_REFINE';
export const SCRIPT_DATES_REFINE_CLEAR = 'SCRIPT_DATES_REFINE_CLEAR';
export const SCRIPT_DATES_GET_GROUP_UPDATER = 'SCRIPT_DATES_GET_GROUP_UPDATER';
export const SCRIPT_DATES_GROUP_UPDATER_FILTER = 'SCRIPT_DATES_GROUP_UPDATER_FILTER';
export const SCRIPT_DATES_GROUP_UPDATER_UPDATES = 'SCRIPT_DATES_GROUP_UPDATER_UPDATES';
export const SCRIPT_DATES_GROUP_UPDATER_CLEAR = 'SCRIPT_DATES_GROUP_UPDATER_CLEAR';
export const SCRIPT_DATES_REFINE_FILTERS_CLEAR = 'SCRIPT_DATES_REFINE_FILTERS_CLEAR';